enum MgrType {
  NORMAL = '0',
  OFFICE_ADMIN = '1',
  SUPER_ADMIN = '9',
}

export default MgrType;
